export const getShortName = (name: string) => {
  const notValid = !name || name?.length === 0 || !name?.trim()
  if (notValid) return ''
  const splittedName = name?.toLowerCase()?.split(' ')

  for (let i = 0; i < splittedName.length; i++) {
    if (splittedName[i]?.trim() || splittedName[i].length > 1) {
      splittedName[i] =
        splittedName[i][0]?.toUpperCase() + splittedName[i]?.substring(1)
    }
  }

  const firstName = splittedName[0]
  const lastName = splittedName[splittedName.length - 1]

  return `${firstName} ${splittedName.length > 1 ? lastName : ''}`
}
